import { render, staticRenderFns } from "./acompanhamentoexames.vue?vue&type=template&id=aa77a5a8&scoped=true&"
import script from "./acompanhamentoexames.vue?vue&type=script&lang=js&"
export * from "./acompanhamentoexames.vue?vue&type=script&lang=js&"
import style0 from "./acompanhamentoexames.vue?vue&type=style&index=0&id=aa77a5a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa77a5a8",
  null
  
)

export default component.exports